export default __webpack_public_path__ + "static/media/icon-concept-validation.28884ec4.svg";